import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { MapPin, Phone, Mail, Instagram, Facebook, Twitter } from 'lucide-react';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <svg viewBox="0 0 100 100" className="w-10 h-10">
                <rect width="100" height="100" rx="20" fill="#F97316"/>
                <g fill="white">
                  <rect x="18" y="25" width="4" height="50" rx="2"/>
                  <rect x="25" y="25" width="3" height="20" rx="1.5"/>
                  <rect x="18" y="25" width="3" height="20" rx="1.5"/>
                  <rect x="11" y="25" width="3" height="20" rx="1.5"/>
                  <ellipse cx="78" cy="35" rx="12" ry="15"/>
                  <rect x="76" y="45" width="4" height="30" rx="2"/>
                  <rect x="30" y="50" width="44" height="8" rx="4"/>
                </g>
              </svg>
              <span className="text-xl font-bold">Hambre</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              {t('footer.aboutText')}
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-orange-500 transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://www.facebook.com/Hambre.biz/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-orange-500 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-orange-500 transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/restaurants" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('nav.restaurants')}
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('footer.about')}
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('footer.faq')}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* For Partners */}
          <div>
            <h4 className="font-semibold text-lg mb-4">{t('footer.partner')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/register?role=restaurant_admin" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('landing.registerRestaurant')}
                </Link>
              </li>
              <li>
                <Link to="/apply/driver" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('footer.becomeDriver')}
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('footer.terms')}
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white transition-colors text-sm">
                  {t('footer.privacy')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact - Temporarily Hidden
          <div>
            <h4 className="font-semibold text-lg mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-slate-400 text-sm">
                <MapPin className="w-4 h-4 text-orange-500 flex-shrink-0 mt-0.5" />
                <span>37 Cort Crescent<br />Leicester<br />LE3 1QH</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Phone className="w-4 h-4 text-orange-500 flex-shrink-0" />
                <span>+44 7564 386111</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Mail className="w-4 h-4 text-orange-500 flex-shrink-0" />
                <span>support@hambre.biz</span>
              </li>
            </ul>
          </div>
          */}
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="text-center md:text-left">
            <p className="text-slate-400 text-sm">
              © {new Date().getFullYear()} Hambre. All rights reserved.
            </p>
            <p className="text-slate-500 text-xs mt-1">
              Hambre is a trading name of AZTRIX MEDIA LTD
            </p>
          </div>
          <div className="flex gap-6">
            <Link to="/terms" className="text-slate-400 hover:text-white text-sm transition-colors">
              Terms
            </Link>
            <Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors">
              Privacy
            </Link>
            <Link to="/cookies" className="text-slate-400 hover:text-white text-sm transition-colors">
              Cookies
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
